import React from 'react';
import './DiscontinuedBrand.less';
import { processTranslation } from '../utils/commonUtil';
import backgroundImage from '../../images/cabin-blue-create-account-page.svg';
import AlertBox from "../Alert/Alert";
import ContinueButtonHolder from '../ButtonHolder/ContinueButtonHolder';
import InfoCard from "../Card/InfoCard";


export default class DiscontinuedBrand extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }

    renderDiscontinuedBrandsContent() {
        const { translations, emailAddress, handleFormSubmit } = this.props;
        return (
            <div className="discontinued-brand-content">

                <div className="main-col">
                    <div className="panel-head">
                        <h1 className="header">{translations['ipmob.discontinued_brand.heading']}</h1>
                    </div>

                    <div className="discontinued-brand-desc">

                        <p
                            className="discontinued-brand-pg-desc-text"
                            /* eslint-disable-next-line react/no-danger */
                            dangerouslySetInnerHTML={{
                                __html: processTranslation(
                                    translations['ipmob.discontinued_brand.desc'],
                                    [emailAddress]
                                )
                            }}
                        />
                        <p className="discontinued-brand-pg-desc-text">{translations['ipmob.discontinued_brand.desc_2']}</p>
                        <p className="discontinued-brand-pg-desc-text">{translations['ipmob.discontinued_brand.desc_3']}</p>
                    </div>

                    <ContinueButtonHolder
                        enableContinueButton
                        handleContinueButtonClick={handleFormSubmit}
                        translations={translations}
                        continueButtonId={'discontinuedBrandsContinueBtn'}
                    />
                </div>

                <div className="spacer-col" />

                <div className="info-card-col">
                    <InfoCard className="discontinued-brand-info-card">
                        <div className="info-card-header">{translations['ipmob.discontinued_brand.info.heading']}</div>
                        {/* eslint-disable-next-line react/no-danger */}
                        <div className="info-card-text" dangerouslySetInnerHTML={{ __html: translations['ipmob.multiple_accounts.lcm.info.desc'] }} />
                    </InfoCard>
                </div>
            </div>
        );
    }

    render() {
        const {
            translations,
            serviceError,
            handleAlertDismiss,
        } = this.props;

        return (<div className="discontinued-brand-pg">
            <div className="discontinued-brand-pg-wrapper container">
                {
                    (serviceError)
                        ? <div className="alert-panel">
                            <AlertBox
                                messageKey={serviceError}
                                translations={translations}
                                handleAlertDismiss={handleAlertDismiss}
                                size={'sm'}
                            />
                        </div>
                        : null
                }
                <img className="discontinued-brand-pg-bg-img" src={backgroundImage()} alt="" />
                <div className="page-content">
                    {this.renderDiscontinuedBrandsContent()}
                </div>
            </div>
        </div>);
    }
}
